import { render } from "./daoruCustomer.vue?vue&type=template&id=db3b9f5c&scoped=true"
import script from "./daoruCustomer.vue?vue&type=script&lang=js"
export * from "./daoruCustomer.vue?vue&type=script&lang=js"

import "./daoruCustomer.vue?vue&type=style&index=0&id=db3b9f5c&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db3b9f5c"]])

export default __exports__